






































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

/* eslint-disable */ 
import { Dealer } from '../models/Dealer'
/* eslint-enable */ 

export default Vue.extend({
  name: 'RegistrationForm',

  data: () => {
    return {
      loading: false as boolean,
      form: {
        first_name: '',
        last_name: '',
        phone_number: '',
        email: '',
        password: '',
        password_confirmation: '',
        dealer_id: 0
      },
      snackbarText: '',
      snackbar: false
    }
  },
  computed: {
    ...mapGetters({
    }),
    currentDealer() : Dealer {
      return this.$store.state.dealers.currentDealer
    },
    obs () : any {
      return this.$refs.observer as any
    }
  },
  methods: {
    ...mapActions({
      register: 'auth/register'
    }),
    async submit() {
      this.loading = true
      this.form.dealer_id = this.currentDealer.id
      const isValid = await this.obs.validate()
        if (isValid) {
          const response = await this.register(this.form)
            if (response === 200 || response === 201) {
              this.loading = false
              this.snackbarText= 'You have successfully registered! You can now sign in.'
              this.snackbar = true
            } else {
              this.loading = false
              this.snackbarText = 'A user with these details already exists in our system.'
              this.snackbar = true
            }
        } else {
          this.loading = false
          this.snackbarText = 'One or more of the fields were invalid. Please try again.'
          this.snackbar = true
        }
    }
  }
})
